import api from "shared/api";

const FETCH_REQUEST = "linkWithOthers/FETCH_REQUEST";
const FETCH_SUCCESS = "linkWithOthers/FETCH_SUCCESS";
const FETCH_FAILURE = "linkWithOthers/FETCH_FAILURE";
const CLEAR_DATA = "linkWithOthers/CLEAR_DATA";

const initialState = {
  result: { title: "", chart_data: [] },
  loaded: false,
  loading: false,
  errors: [],
};

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  };
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  };
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  };
}

export function clearData() {
  return {
    type: CLEAR_DATA,
  };
}

export function loadLinkWithOthers(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchRequest());

    const promise = api(`api/v1/directors/${id}/link_with_director`, options)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(fetchSuccess(json));
      })
      .catch((json) => {
        toastr["error"](json.errors);
        dispatch(fetchFailure(json.errors));
      });

    return promise;
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      });
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        result: {
          ...state.result,
        },
        errors: errors,
      };

    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
}
